<template>
    <div :class="['task-prop', 'task-prop_date', {'task-prop_disabled': this.disabled}]">
        <strong class="task-prop__label">{{ label }}</strong>

        <div v-if="disabled" class="task-prop__value component--select">
            <div class="placeholder placeholder_inline placeholder_icon" style="cursor: default">
                {{ formattedDate }}
            </div>
        </div>

        <Calendar
            v-else
            class="task-prop__value component--select"
            :value="value || new Date()"
            @input="v => $emit('update', v)"
        />
    </div>
</template>

<script>
import Calendar from "@common/vue/components/form/Calendar";
import {dateToDMY} from "@common/utils/date";

export default {
    name: "PlanPropDate",
    components: {Calendar},
    props: {
        label: {
            type: String,
        },
        value: {
        },
        disabled: {
            type: Boolean,
        },
    },
    computed: {
        formattedDate() {
            return dateToDMY(this.value);
        },
    },
}
</script>

<style lang="scss">
.task-prop_date {
    .mx-datepicker-inline {
        z-index: 100;
        position: absolute;
        top: 40px;
        right: 0;
    }

    .task-prop__value {
        width: 100%;
        max-width: 250px;
        cursor: pointer;
    }
}

.task-prop_date-start, .task-prop_date-finish {
    .task-prop__label {
        margin-right: auto;
    }

    .task-prop__value {
        width: 100%;
        max-width: 250px;
    }
}

.task-prop_disabled {
}
</style>
